module.exports = __webpack_public_path__ + "img/trailer_front_right.0da73ca6.png";